import React from 'react';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';

import CustomSwitch from '../../../partials/CustomSwitch';
import { actions as reduxActions } from '../reducers';
import styles from '../styles/tableSwitch';
import { translate } from '../../../i18n/I18nProvider';

const TableSwitch = ({
  setIsConnectRangesTable,
  classes,
  isConnectRangesTable
}) => {
  const handleSwitch = e => {
    setIsConnectRangesTable(e.target.checked);
  };

  return (
    <div className={classes.root}>
      <div className={classes.switchRow}>
        <div>{translate('MENU.EXTERNAL_NUMBER')}</div>
        <CustomSwitch
          checked={isConnectRangesTable}
          handleChange={handleSwitch}
        />
        <div>{translate('MENU.CONNECT_RANGES')}</div>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ externalNoRanges, auth }) => {
  return {
    isConnectRangesTable: externalNoRanges.isConnectRangesTable,
    lang: auth.lang
  };
};

const mapDispatchToProps = {
  setIsConnectRangesTable: reduxActions.setIsConnectRangesTable
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(TableSwitch);
